var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "047---Autosave",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26,
    cy: 26,
    fill: "#285680",
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26,
    cy: 26,
    fill: "#b0d3f0",
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#285680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 4.03v1.97c0 .55228475-.4477153 1-1 1s-1-.44771525-1-1v-1.97c.33-.02.66-.03 1-.03s.67.01 1 .03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 46v1.98c-.33.01-.67.02-1 .02s-.67-.01-1-.03v-1.97c0-.5522847.4477153-1 1-1s1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16.5 9.55c-.4811967.27057145-1.0904405.10603113-1.37-.37l-.99-1.71c.5615168-.36754734 1.1423519-.70469871 1.74-1.01l.99 1.72c.2723004.48097949.1074157 1.09149858-.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m9.55 16.5c-.27955946.4760311-.88880334.6405714-1.37.37l-1.72-.99c.31-.59.64-1.17 1.01-1.74l1.71.99c.47741568.2785014.64230039.8890205.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 26c0 .5522847-.44771525 1-1 1h-1.97c-.02-.33-.03-.66-.03-1s.01-.67.03-1h1.97c.55228475 0 1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45 26c0 .5522847.4477153 1 1 1h1.97c.02-.33.03-.66.03-1s-.01-.67-.03-1h-1.97c-.5522847 0-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m9.18 36.87-1.71.99c-.37-.57-.7-1.15-1.01-1.74l1.72-.99c.31082106-.1786328.69333103-.1778752 1.0034421.0019873s.50070999.5115047.5.87-.19262104.6893799-.5034421.8680127z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45.54 15.88-1.72.99c-.4804877.2761424-1.0938576.1104877-1.37-.37-.2761423-.4804877-.1104877-1.0938576.37-1.37l1.71-.99c.37.57.7 1.15 1.01 1.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16.87 43.82-.99 1.72c-.5976481-.3053013-1.1784832-.6424527-1.74-1.01l.99-1.71c.1786328-.3108211.5095174-.5027321.8680127-.5034421s.6901375.1898889.87.5c.1798626.3101111.1806201.692621.0019873 1.0034421z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37.86 7.47-.99 1.71c-.1786328.31082106-.5095174.50273211-.8680127.5034421s-.6901375-.18988893-.87-.5-.1806201-.69262104-.0019873-1.0034421l.99-1.72c.5976481.30530129 1.1784832.64245266 1.74 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m17 35c-.4153978.0001252-.7876174-.2565696-.9351275-.6448944-.1475101-.3883247-.0395901-.8274066.2711275-1.1031056l8.664-7.701v-14.551c0-.5522847.4477153-1 1-1s1 .4477153 1 1v15c.0000764.2859007-.1222227.5581619-.336.748l-9 8c-.1830442.1624147-.4192885.2520737-.664.252z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 38v18c0 1.1045695-.8954305 2-2 2h-20c-1.1045695 0-2-.8954305-2-2v-20c0-1.1045695.8954305-2 2-2h17z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 34v7c0 .5522847-.4477153 1-1 1h-12c-.5522847 0-1-.4477153-1-1v-7",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 40c-.5522847 0-1-.4477153-1-1v-2c0-.5522847.4477153-1 1-1s1 .4477153 1 1v2c0 .5522847-.4477153 1-1 1z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39 46h14c.5522847 0 1 .4477153 1 1v11h-16v-11c0-.5522847.4477153-1 1-1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50 51h-8c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h8c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
    fill: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50 55h-8c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h8c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
    fill: "#a5a5a4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTime);
export default __webpack_public_path__ + "static/media/save-time.d6e66929eb1e4d799b7a59fb6be4c61c.svg";
export { ForwardRef as ReactComponent };